import axios from "./axios";
import {
  LOGIN,
  VERIFY_EMAIL_CODE,
  LOGIN_BY_TOKEN,
  CHANGE_PASSWORD,
  RESET_PASSWORD,
  LOGOUT,
  SELECT_MERCHANT,
  CREATE_ATTENDANCE_LOG,
  UPDATE_ATTENDANCE_LOG,
} from "./APILinks";
import moment from "moment";

export const login = (email, password) => axios.post(LOGIN, { email: email, password });

export const verifyEmailCode = (email, verifyCode) =>
  axios.post(VERIFY_EMAIL_CODE, {
    email: email,
    verifyEmailCode: verifyCode,
  });

export const selectMerchant = (merchantId) =>
  axios.post(SELECT_MERCHANT, {
    merchant_id: merchantId,
  });

export const loginByToken = (token) => axios.post(LOGIN_BY_TOKEN);

export const forgetPassword = (email) => axios.post(RESET_PASSWORD, { email });

export const resetPassword = (token, newPassword) =>
  axios.put(
    RESET_PASSWORD,

    { newPassword },

    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const changePassword = ({ newPassword, currentPassword } = {}) =>
  axios.put(CHANGE_PASSWORD, { newPassword, currentPassword });

export const logout = () => axios.post(LOGOUT);

export const postCreateAttendance = async (payload) => {
  try {
    const formatDate = (raw) => 
      raw ? moment(raw, "DD MMM YYYY, HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : null;

    const param = {
      user_id: payload.user_id,
      user_email: payload.user_email,
      user_role: payload.user_role,
      store_name: payload.store_name,
      clock_in_at: formatDate(payload.clock_in_at) || null,
      clock_out_at: formatDate(payload.clock_out_at) || null,
    }

    return axios.post(
      CREATE_ATTENDANCE_LOG,
      param
    );
  } catch (e) {
    console.error("Failed to send attendance log:", e);
    throw e;
  }
};

export const putUpdateAttendance = async (attendanceId, clockOutAt) => {
  const formatDate = (raw) => 
      raw ? moment(raw, "DD MMM YYYY, HH:mm:ss").format("YYYY-MM-DD HH:mm:ss") : null;

  return axios.put(
    `${UPDATE_ATTENDANCE_LOG}/${attendanceId}`,
    { clock_out_at: formatDate(clockOutAt) }
  );
};
